export default __webpack_public_path__ + "static/media/class_v_vi_tab.a730ca4d.png";